// extracted by mini-css-extract-plugin
export default {"article":"colorpicker_article__ZGqON","itemBx":"colorpicker_itemBx__U-v-K","colorItem":"colorpicker_colorItem__Rz1+D","buttonNewColor":"colorpicker_buttonNewColor__ClZLl"};